export default __webpack_public_path__ + "static/media/done.c726481c.svg";